module.exports = __webpack_public_path__ + "img/temoignage-8-rounded.77e6922f.jpg";